import { useFetch } from './useFetch'
import type { ConfigDTO, ConfigFilters } from '../types'

const extractConfigs = (json: unknown) =>
  (json as { configs: ConfigDTO[] }).configs

const EMPTY_FILTERS: ConfigFilters = {
  tenant: '',
  isp: '',
  venue: '',
  configKey: '',
  tags: [],
}

// Fetch the tenant-config list, threading applied filters into the query params
// the API expects. The four exact-match column filters map to their plural API
// param names; tags is comma-joined. Every supplied filter AND-combines
// server-side, and omitting all of them leaves the unfiltered list unchanged.
export function useConfigs(filters: ConfigFilters = EMPTY_FILTERS) {
  const params = new URLSearchParams()

  const columnParams: [string, string][] = [
    ['tenantCodes', filters.tenant],
    ['inventorySystemProfileCodes', filters.isp],
    ['venueIds', filters.venue],
    ['configKeys', filters.configKey],
  ]

  columnParams.forEach(([name, value]) => {
    if (value) {
      params.set(name, value)
    }
  })

  if (filters.tags.length) {
    params.set('tags', filters.tags.join(','))
  }

  const queryString = params.toString()
  const path = queryString
    ? `/v1/tenant-configs?${queryString}`
    : '/v1/tenant-configs'

  const {
    data: configs,
    isLoading,
    error,
  } = useFetch<ConfigDTO[]>(path, [], extractConfigs)
  return { configs, isLoading, error }
}
